export interface fechasModalExportacion {
  fechaDesde: string;
  fechaHasta: string;
  
}

export const initValuesFechasModalExportacion = {
  fechaDesde: "",
  fechaHasta: "",
};
